import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Card, Container } from "react-bootstrap";
import clientData from './ClientsImages/ClientsImages.json';
import Swal from "sweetalert2";

// Function to import all images from ClientsImages folder
function importAll(r) {
  let images = {};
  r.keys().forEach((item) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
}
 
// Import all images at once
const clientImages = importAll(require.context("./ClientsImages", false, /\.(png|jpe?g|svg)$/));

// Update clients data with correct image paths
const clients = clientData.clients.map(client => ({
  ...client,
  logo: clientImages[client.logo] // Assign preloaded images
}));



const ClientSlider = () => {
  const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 5, // Show 4 cards at a time
  slidesToScroll: 5, // Scroll 4 slides on arrow click
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 3, slidesToScroll: 3 }, // Move 3 slides at a time
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 2, slidesToScroll: 2 ,dots:false}, // Move 2 slides at a time
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1, slidesToScroll: 1 ,dots:false}, // Move 1 slide at a time
    },
  ],
};

const handlepop = (id) => {
  const selectedClient = clients.find(c => c.id === id);

  Swal.fire({
    customClass: {
      popup: 'custom-swal-popup pop-inner'
    },
    showConfirmButton: false,
    width: 300,
    background: '#ffffff',
    html: `
      <div style="border-radius: 12px; overflow: hidden; font-family: 'Segoe UI', sans-serif;">
        <!-- Header image -->
        <div style="width: 100%; height: auto;">
          <img src=${selectedClient.logo} alt="Customer Testimonials" style="width: 50%; height:20%;" />
        </div>

        <!-- Quote icon -->
        <div style="padding: 15px 25px; text-align: left;  
">
          <div style="font-size: 40px; margin-bottom: 1px;color:gray;" >“</div>

          <!-- Description list -->
          <ul style="padding-left: 20px; font-size: 14px; color:black; list-style: none;">
            ${selectedClient.desc.map(item => `<li style="margin-bottom: 8px;">${item}</li>`).join('')}
          </ul>
        </div>

        <!-- Footer -->
        <div style="background-color: #000; color: white; padding: 10px 20px;">
          <span style="font-size: 12px;">Managing Director</span>
        </div>
      </div>
    `
              //  <strong style="font-size: 14px;">${selectedClient.name.toUpperCase()}</strong><br>

  });
};

// const clients = [
//     { name: "Client One", desc: "A trusted partner in innovation.", logo: clientImages[0] },
//     { name: "Client Two", desc: "Leading industry with cutting-edge solutions.", logo: clientImages[1] },
//     { name: "Client Three", desc: "Providing top-tier business services worldwide.", logo: clientImages[2] },
//     { name: "Client Four", desc: "Excellence in digital transformation.", logo: clientImages[3] },
//     { name: "Client Five", desc: "Innovating for a better future.", logo: clientImages[4] },
//     { name: "Client Six", desc: "Empowering businesses through technology.", logo: clientImages[5] },
//     { name: "Client Seven", desc: "Driving success with advanced solutions.", logo: clientImages[6] },
//     { name: "Client Eight", desc: "Delivering excellence worldwide.", logo: clientImages[7] },
//     { name: "Client Nine", desc: "Transforming businesses with expertise.", logo: clientImages[8] },
//     { name: "Client Ten", desc: "Innovative solutions for modern challenges.", logo: clientImages[9] },
//     { name: "Client Eleven", desc: "Your partner in digital success.", logo: clientImages[10] },
//     { name: "Client Twelve", desc: "Pioneering change through technology.", logo: clientImages[11] },
//     { name: "Client Thirteen", desc: "Global leaders in strategic solutions.", logo: clientImages[12] },
//     { name: "Client Fourteen", desc: "Creating value through innovation.", logo: clientImages[13] },
//     { name: "Client Fifteen", desc: "Empowering industries through insights.", logo: clientImages[14] },
//     { name: "Client Sixteen", desc: "Expertise that drives results.", logo: clientImages[15] },
//     { name: "Client Seventeen", desc: "Revolutionizing industries with AI.", logo: clientImages[16] },
//     { name: "Client Eighteen", desc: "Enhancing efficiency through automation.", logo: clientImages[17] },
//     { name: "Client Nineteen", desc: "Next-gen solutions for businesses.", logo: clientImages[18] },
//     { name: "Client Twenty", desc: "Innovating at the speed of business.", logo: clientImages[19] },
//     { name: "Client Twenty-One", desc: "Leading the way in digital transformation.", logo: clientImages[20] },
//     { name: "Client Twenty-Two", desc: "Success powered by smart solutions.", logo: clientImages[21] },
//     { name: "Client Twenty-Three", desc: "Your vision, our expertise.", logo: clientImages[22] },
//     { name: "Client Twenty-Four", desc: "Driving excellence in every project.", logo: clientImages[23] },
//     // { name: "Client Twenty-Five", desc: "Innovative strategies for growth.", logo: clientImages[24] }
// ];




  return (
    <Container className="my-5">
     <h2 class="theeblock__title text-2xl md:text-3xl lg:text-4xl  text-center mb-4 fw-bold">Our Customers</h2>      
     <Slider {...settings} className="px-2">
        {clients.map((client) => (
          <div key={client.id} className=""> {/* Added horizontal padding */}
            <Card className="client-card border-0 shadow text-center p-3 mb-4" onClick={()=>handlepop(client.id)}>
              <div className="client-logo-container "style={{cursor:'pointer'}}>
                <Card.Img variant="top" loading="lazy" src={client.logo} alt={client.name} className="client-logo" height={200}width={300} />
              </div>
             
            </Card>
          </div>
        ))}
      </Slider>

      {/* Custom CSS */}
      <style>
        {`
          .client-card {
            background: #fff;
            border-radius: 15px;
            overflow: hidden;
            margin: 0 auto;
            max-width: 200px;
            min-height: 120px; /* Ensures all cards are the same height */
            display: flex;
            flex-direction: column;
          }

          .client-logo-container {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100px;
            background: #f8f9fa;
          }

          .client-logo {
            max-width: 120px;
            height: auto;
            border-radius: 10px;
          }

          .card-body {
            flex-grow: 1; /* Ensures even spacing in all cards */
          }
        `}
      </style>
    </Container>
  );
};

export default ClientSlider;
